import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import Assignee from 'components/sales/formSection/assignee/assignee';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import { Button } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import AddPoc from "../../../components/sales/formSection/addPoc/addPoc";
import { ToastContainer, toast } from "react-toastify";

const UpdatePoc = ({
                          match,
                          savePoc,
                          getDetails,
                          viewDetails,
                          history,
                        }) => {
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setsiteId] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isRequired, setRequired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [existingPocData, setExistingPocData] = useState();
  const [pocData, setPocData] = useState(null);
  const { baseUrl } = useContext(BaseUrl);
  const inputs = {
    assigneeDetail: null,
  };
  const [assigneeData, setAssigneeData] = useState(inputs);

  useEffect(() => {
    (async () => {
        const requestData = {
          lead_id: match.params.leadId,
          site_id: match.params.siteId
        };
      setIsLoading(true);
        const res = await getDetails(requestData);
        setIsLoading(false);
    })();
  }, [getDetails, match.params.leadId]);

  useEffect(() => {
    if (viewDetails) {
      setExistingPocData(viewDetails?.postsale_data);
    }
  }, [viewDetails]);

  const handleAssignee = (val) => {
    setAssigneeData({ ...assigneeData, assigneeDetail: val });
  };
  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/brand-activation/sites-listing`);
  };
  const handleSubmit = async () => {
    if (pocData === null) {
      toast.error('Please fill all valid data!');
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsLoading(true);
      const res = await savePoc({pocData: pocData,siteId: match.params.siteId});
      if (res) {
        setIsFiled(false);
        setIsModal(true);
      }
      setIsLoading(false);
    }
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };
  return (
    <Layout
      title={localization.updatePoc}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      <AddPoc
        handleValue={setPocData}
        prefilledData={existingPocData}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={`${baseUrl}/brand-activation/sites-listing`}
            className="btn btn-primary mb-4"
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

UpdatePoc.propTypes = {};

export default UpdatePoc;
